import React from 'react';
import styled from 'styled-components';
import { Box } from 'rebass';

const PrintBox = styled(({ display, after, before, ...restProps }) => <Box {...restProps} />)`
  @media print {
    display: ${props => props.display};
    page-break-after: ${props => (props.after ? 'always' : 'auto')};
    page-break-before: ${props => (props.before ? 'always' : 'auto')};
  }
`;

export default PrintBox;
